import React, { useEffect } from 'react'
import { Col, Grid, Row } from 'react-bootstrap'
import { useHistory } from 'react-router'
import LoginForm from './components/LoginForm'

const Login = () => {
  const history = useHistory()

  useEffect(() => {
    const { token } = window.localStorage

    if (token?.length > 10) {
      history.push('/')
    }
  }, [])

  return (
    <Grid fluid style={{ position: window.isMobile ? 'fixed' : 'relative' }}>
      <Row style={{ marginTop: '20%' }}>
        <Col xs={12} md={4} lg={4}>
          &nbsp;
        </Col>
        <Col xs={12} md={4} lg={4} style={{ textAlign: 'center' }}>
          <LoginForm />
        </Col>
        <Col xs={12} md={4} lg={4}>
          &nbsp;
        </Col>
      </Row>
    </Grid>
  )
}

export default Login
